<template>
  <div class="l-main">
    <div class="l-main__header">
      <ul class="c-breadcrumbs">
        <li class="c-breadcrumbs__item">
          <a
            class="c-breadcrumbs__link"
            @click="goToHome"
          > 
            <md-icon>home</md-icon>
            <span>Home</span>
          </a>
        </li>
        <li class="c-breadcrumbs__item--separator">
          /
        </li>
        <li class="c-breadcrumbs__item is-current">
          <a class="c-breadcrumbs__link c-breadcrumbs__home">Trending Configuration</a>
        </li>
      </ul>
    </div>
    <div class="l-main__ctn u-box">
      <div class="l-trending-page"> 
        <div class="l-trending-page-top">
          <md-field class="u-width-m u-mb-xs">
            <label>Select sports</label>
            <md-select v-model="selectedSportId" md-dense>
              <md-option
                v-for="sport in sports"
                :key="sport.name"
                :value="sport.id"
              >
                {{ sport.name }}
              </md-option>
            </md-select>
          </md-field>
          <div style="position: relative;">
            <md-field v-if="selectedSportId !== -1" class="c-select-field u-mb-0">
              <label>Search template id</label>
              <md-input
                @click="toggleDropdown"
                @input="filterTerms"
              />
            </md-field>
            <div
              v-if="isDropdownOpen"
              v-click-outside="onClickOutside"
            >
              <ul class="c-search-multiselect__dropdown" style="top: 100%">
                <li
                  v-for="(template) in filteredTemplates"
                  :key="template.gameTemplateId"
                >
                  <md-checkbox
                    v-model="selectedTemplate[selectedSportId]"
                    :value="template.gameTemplateId"
                    class="c-dropdown__checkbox"
                    @change="onInputChange"
                  >
                    {{ template.gameTemplateId }} - {{ template.gameTemplateName }}
                  </md-checkbox>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div style="display: flex;">
          <div v-if="selectedSportId !== -1">
            <div class="c-table-wrapper">
              <div class="c-table-markets">
                <div>
                  {{ selectedTemplate[selectedSportId]?.length ? "Selected markets for sport:" : `No selected markets for sport id ${selectedSportId}` }}
                </div>
                <div class="c-single-market">
                  <div
                    v-for="templateId in selectedTemplate[selectedSportId]"
                    :key="templateId"
                    class="c-single-market__inner"
                  >
                    {{ templateId }} 
                    <generic-button
                      icon
                      transparent
                      text-inherit
                      @click="removeSelection(templateId)"
                    >
                      <md-tooltip md-direction="top">
                        Delete
                      </md-tooltip>
                      <img src="../../assets/delete-button.svg" alt="">
                    </generic-button> 
                  </div>    
                </div>
              </div>
              
              <div class="c-table c-table--trending">
                <div class="c-table__head">
                  <div class="c-table__cell c-table__cell-left">
                    <span>Website Name</span>
                  </div>
                  <div class="c-table__cell c-table__cell-right">
                    <span>Template Ids</span>
                  </div>
                </div>
                <div class="c-table__body">
                  <div
                    v-for="website in allWebsites"
                    :key="website.id"
                    class="c-table__row"
                    :value="website.id"
                  >
                    <div class="c-table__row-left">
                      {{ website.name }}
                    </div>
                    <div class="c-table__row-right">
                      <div
                        v-for="templateId in selectedTemplate[selectedSportId]"
                        :key="templateId"
                        class="c-tranding-label"
                      >
                        <label :for="website.id + '-' + templateId">{{ templateId }}</label>
                        <input :id="website.id + '-' + templateId" v-model="website.sports[selectedSportId]" type="checkbox" :value="templateId" @change="onTemplateChange">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            Select sport to start selecting template ids
          </div>
        </div>
        <generic-button
          v-if="selectedSportId !== -1"
          style="margin-top: 15px !important"
          variation="red"
          :disabled="!somethingChange"
          @click="saveConfiguration"
        >
          Save
        </generic-button>
      </div>
    </div>
  </div>
</template>
<script>
import {websiteService} from "@/services/websites";
import GenericButton from "../../shared/buttons/GenericButton";
import { trendingConfigurationService } from "@/services/trending-configuration";
import { mapActions } from 'vuex'


export default {
    components: {
      GenericButton
    },
    data() {
    return {    
      allWebsites: [],
      selectedSportId: -1,
      somethingChange: false,
      sports: [
        { id: -1, name: 'Select sport'},
        { id: 54, name: 'Volleyball' },
        { id: 55, name: 'Basketball' },
        { id: 56, name: 'Tennis' },
        { id: 57, name: 'LiveFudbal' },
        { id: 58, name: 'Football' },
        { id: 59, name: 'Ice Hockey' },
        { id: 60, name: 'Handball' },
        { id: 61, name: 'NFL' },
        { id: 62, name: 'Waterpolo' },
        { id: 63, name: 'Baseball' },
        { id: 65, name: 'Rugby Union' },
        { id: 66, name: 'Cricket' },
        { id: 67, name: 'Formula 1' },
        { id: 68, name: 'Motor Sport' },
        { id: 69, name: 'Snooker' },
        { id: 70, name: 'TennisATP' },
        { id: 71, name: 'TennisWTA' },
        { id: 72, name: 'Cycling' },
        { id: 73, name: 'Politics' },
        { id: 75, name: 'Eurovision' },
        { id: 76, name: 'Boxing' },
        { id: 77, name: 'Special Offer' },
        { id: 78, name: 'Goalscorers' },
        { id: 79, name: 'Athletics' },
        { id: 80, name: 'American Football' },
        { id: 81, name: 'Alpine Skiing' },
        { id: 82, name: 'Virtual Football' },
        { id: 83, name: 'Rally' },
        { id: 84, name: 'Football Outrights' },
        { id: 85, name: 'Golf' },
        { id: 86, name: 'Darts' },
        { id: 87, name: 'Martial Arts' },
        { id: 89, name: 'Table Tennis' },
        { id: 90, name: 'Badminton' },
        { id: 91, name: 'Beach Volleyball' },
        { id: 92, name: 'Beach Soccer' },
        { id: 93, name: 'Futsal' },
        { id: 94, name: 'Rugby League' },
        { id: 95, name: 'Ski Jumping' },
        { id: 96, name: 'Horse Racing' },
        { id: 97, name: 'Trotting' },
        { id: 98, name: 'Specials' },
        { id: 99, name: 'Biathlon' },
        { id: 100, name: 'Rowing' },
        { id: 101, name: 'Swimming' },
        { id: 102, name: 'Shooting' },
        { id: 103, name: 'Kiron' },
        { id: 104, name: 'Basketball NCAA' },
        { id: 106, name: 'Winter Olympics' },
        { id: 107, name: 'Bowls' },
        { id: 108, name: 'Cross Country Skiing' },
        { id: 109, name: 'Chess' },
        { id: 112, name: 'Pool' },
        { id: 113, name: 'Curling' },
        { id: 115, name: 'Squash' },
        { id: 116, name: 'Football 80' },
        { id: 117, name: 'Netball' },
        { id: 118, name: 'Bandy' },
        { id: 119, name: 'Sport Specials' },
        { id: 120, name: 'Aussie Rules' },
        { id: 122, name: 'eSports' },
        { id: 123, name: 'Olympic Games' },
        { id: 124, name: 'Surfing' },
        { id: 126, name: 'Hockey' },
        { id: 129, name: 'Basketball 3x3' },
        { id: 130, name: 'ESport Counter-Strike' },
        { id: 131, name: 'ESport Call of Duty' },
        { id: 132, name: 'ESport Dota' },
        { id: 133, name: 'ESport Hearthstone' },
        { id: 134, name: 'ESport League of Legends' },
        { id: 135, name: 'ESport NBA2K' },
        { id: 136, name: 'ESport Overwatch' },
        { id: 137, name: 'ESport StarCraft' },
        { id: 138, name: 'ESport Rainbow Six' },
        { id: 139, name: 'ESport Rocket League' },
        { id: 140, name: 'ESport King of Glory' },
        { id: 143, name: 'Speedway' },
        { id: 144, name: 'Virtual Tennis' },
        { id: 177, name: 'Virtual Basketball' },
        { id: 178, name: 'Floorball' },
        { id: 179, name: 'Virtual Ice Hockey' },
        { id: 212, name: 'Lacrosse' },
        { id: 213, name: 'Nascar' },
        { id: 246, name: 'ESport Valorant' },
        { id: 247, name: 'ESport Mobile Legends' },
        { id: 248, name: 'ESport Freefire' },
        { id: 249, name: 'ESport Wild Rift' },
        { id: 250, name: 'ESport Apex Legend' },
        { id: 251, name: 'ESport Warcraft III' },
        { id: 252, name: 'ESport Arena of Valor' },
        { id: 253, name: 'ESport Street Fighter' },
        { id: 254, name: 'Beach Handball' },
        { id: 255, name: 'Bowling' },
        { id: 256, name: 'Hurling' },
        { id: 257, name: 'Air Hockey' },
        { id: 258, name: 'ESport Archery' },
        { id: 259, name: 'Pesapallo' },
        { id: 260, name: 'Rink Hockey' },
        { id: 261, name: 'BC Archery' },
        { id: 263, name: 'Archery' },
        { id: 264, name: 'WWE' },
        { id: 265, name: 'ESport CrossFire' },
        { id: 266, name: 'Gaelic Football' },
        { id: 267, name: 'Kabaddi' },
        { id: 268, name: 'Taekwondo' },
        { id: 269, name: 'Judo' },
        { id: 270, name: 'Karate' },
        { id: 271, name: 'Esport Brawl Stars' },
        { id: 272, name: 'Esport Clash Royale' },
        { id: 273, name: 'Esport Heroes of Newerth' },
        { id: 274, name: 'Esport World of Warcraft' },
        { id: 275, name: 'Esport Heroes of the Storm' },
        { id: 277, name: 'Esport Street Fighter V' },
        { id: 278, name: 'Esport StarCraft 2' },
        { id: 280, name: 'Esport Age of Empires' },
        { id: 281, name: 'Esport Artifact' },
        { id: 282, name: 'Esport Camogie' },
        { id: 283, name: 'Esport Gears of War' },
        { id: 284, name: 'Esport Gwent' },
        { id: 285, name: 'Esport Mortal Kombat 11' },
        { id: 286, name: 'Esport Overwatch 2' },
        { id: 287, name: 'Esport Pubg' },
        { id: 288, name: 'Esport Sepak Takraw' },
        { id: 289, name: 'Esport Tekken 7' },
        { id: 290, name: 'Esport Vaingloory' },
        { id: 291, name: 'Esport World of Tanks' },
        { id: 292, name: 'Pelota' },
        { id: 293, name: 'Rugby Sevens' },
        { id: 294, name: 'Softball' },
        { id: 295, name: 'Sumo' },
        { id: 296, name: 'Teqball' },
        { id: 297, name: 'Ultimate Frisbee' },

      ],
      dataForSaving: {},
      searchQueryTemplate: '',
      selectedTemplate: {},
      filteredTemplates: [],
      debouncedFilterSports: '',
      isDropdownOpen: false,
      templates: [], 
    }
  },

  async created() {
    this.sports.forEach(sport => {
      this.selectedTemplate[sport.id] = [];
    });
    await this.getConfiguration();
    await this.getWebsites();
    this.filteredTemplates = this.templates
    this.debouncedFilterSports = this.debounce(this.filterSports, 100);
  },

  methods: {
     ...mapActions('response', ['handleSuccess', 'handleError']),
    onInputChange(event) {
      this.somethingChange = true;
      this.allWebsites.forEach((website, index) => {
        const indexOf = this.allWebsites[index].sports[this.selectedSportId].indexOf( event[0]);
        if(indexOf !== -1) {
          return;
        }
      })
    },

    removeSelection(templateId) {
      this.somethingChange = true;

      const templateIndex = this.selectedTemplate[this.selectedSportId].indexOf(templateId);
      if(templateIndex === -1) {
        return;
      }

      this.selectedTemplate[this.selectedSportId].splice(templateIndex, 1)
      this.selectedTemplate[this.selectedSportId].filter((id) => id === templateId)
      this.allWebsites.forEach((website, index) => {
        const indexOf = this.allWebsites[index].sports[this.selectedSportId].indexOf(Number(templateId));
        if(indexOf !== -1) {
           this.allWebsites[index].sports[this.selectedSportId].splice(indexOf, 1)
          return;
        }
      })
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    onTemplateChange() {
      this.somethingChange = true;
    },
    goToHome() {
      this.$router.push({ name: 'home' });
    },
    filterTerms(term) {
      if(term.length < 2) {
        this.filteredTemplates = []
        return;
      }
        this.filteredTemplates = this.templates.filter((template) =>{
          return  String(template.gameTemplateName).toLowerCase().includes(term.toLowerCase()) || String(template.gameTemplateId) === term.toLowerCase()

        }
      );
      this.isDropdownOpen = true;

    },
    onClickOutside() {
      this.isDropdownOpen = false;
    },
    
    async getWebsites(page = 1, limit = 1) {
      const response = await websiteService.getWebsites(page, limit);
      this.allWebsites = response.data;
     
      this.sports.forEach((sport) => {
      if(sport.id === -1) {
        return;
      }
      this.allWebsites.forEach((website, index) => {
        if(!this.allWebsites[index].sports) {
          this.allWebsites[index].sports = {}
        }
        this.allWebsites[index].sports = {
          ...this.allWebsites[index].sports,
          [sport.id]: (this.dataForSaving[this.allWebsites[index].betshop.id] && this.dataForSaving[this.allWebsites[index].betshop.id][sport.id]) ?  this.dataForSaving[this.allWebsites[index].betshop.id] [sport.id]: [],
        }
      })
    })
    },
    handleInput() {
      this.debouncedFilterSports();
    },
    debounce(func, wait) {
      let timeout;
      return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(context, args);
        }, wait);
      };
    },

    async saveConfiguration() {
      this.allWebsites.forEach((website) => {
        this.dataForSaving[website.betshop.id] = website.sports

      })

      try {
        let selectedTemplateForSaving = {};
        Object.keys(this.selectedTemplate).forEach((elements) => {
          if (this.selectedTemplate[elements].length === 0) {
            return;
          }
          selectedTemplateForSaving[elements] = this.selectedTemplate[elements];
        });

        await trendingConfigurationService.save({markets: this.dataForSaving, templates: this.selectedTemplate})
        this.somethingChange = false;
        this.handleSuccess({ message: 'Configuration saved successfully' });
      } catch (error) {
        this.handleError({ message: 'Failed to save configuration' });
      }

    },

    async getConfiguration() {
        const marketTemplates = await trendingConfigurationService.getMarketTemplates();
        this.templates = marketTemplates.data
        const savedConfig = await trendingConfigurationService.getConfig();
        if(savedConfig.data.length) {
          this.dataForSaving = savedConfig.data[0]?.markets;
          this.selectedTemplate = savedConfig.data[0]?.templates;
        }
     
    }
  }
}
</script>

<style lang="scss" scoped>
$input-padding: 10px;
$container-padding: 8px;

.l-trending-page {
  padding: 10px 15px
}
.l-trending-page-top {
  display: flex; 
  gap: 50px;
  margin-bottom: 15px;
}

.c-table-markets {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

.c-single-market {
  display: flex;
  flex-wrap: wrap;
}

.c-single-market__inner {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 90px;
}

.u-flex-row-center {
  width: 100%;
  padding-bottom: 20px;
}

.md-icon-button {
  height: calc(28px + 1.5rem);
  aspect-ratio: 1/1;
}

.c-header-container {
  padding: $container-padding;
  display: flex;
  flex-direction: column;
  position: relative;

  .md-button {
    min-width: 0 !important;
  }
}

.c-input_group_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 0.5rem;
  background-color: $grey-light-01;
  padding: $container-padding $container-padding calc(8px + 1.25rem);

  .meridian-theme-dark & {
    background-color: $grey-darker;
  }
}

.c-header-container__filters {
  flex-direction: row;
  background-color: transparent;
  align-items: flex-end;
  padding: 0;
  @extend .c-input_group_container;

  .md-button:not(:last-child) {
    @extend .md-icon-button;
  }
}

.c-header-container__filter-buttons {
  background-color: transparent;
  align-items: flex-end;
  height: 100%;
  @extend .c-header-container__filters;

  .md-button:first-child {
    @extend .md-icon-button;
  }
}

.c-filter-modal {
  position: absolute;
  top: calc(1.5rem + 60px); // button height + 2 * container padding
  right: $container-padding;
  background-color: $white;
  width: calc(100% - 16px);
  z-index: 11;
  padding: $container-padding;
  border-radius: 4px;

  &.hidden {
    visibility: hidden;
  }

  .md-button {
    transition: none;
  }

  .meridian-theme-dark & {
    background-color: $grey-darker;
  }
}

.c-header-container__tags {
  display: flex;
  gap: $container-padding;
  flex-wrap: wrap;
  flex: 1;
}

.c-tag {
  background-color: $grey;
  color: $white;
  display: flex;
  align-items: center;

  .md-button {
    box-shadow: none;
    height: fit-content;
    width: fit-content;
    box-sizing: border-box;
    min-width: fit-content;

    :first-child {
      padding: 0 0 0 2px;
    }

    .md-icon {
      font-size: 16px !important;
      min-width: none;
    }
  }
}

.c-filter-buttons-container {
  display: flex;
  gap: $container-padding;
  align-items: center;
  justify-content: flex-end;
}

.c-filters-container {
  display: flex;
  gap: $container-padding;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
}

.c-input_group {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  min-width: 300px;
  max-width: 450px;

  label {
    color: $grey;
    font-size: 1.25rem;
    margin-left: 5px;
    
    .meridian-theme-dark & {
      color: $white;
    }
  }

  input, select {
    border: 1px solid $grey-01;
    padding: $input-padding;
    caret-color: $grey;
    font-size: 1.5rem;
    border-radius: 2px;
    background-color: transparent;
    color: $black;
    flex: 1;
    font-family: 'Roboto', sans-serif;

    .meridian-theme-dark & {
      caret-color: $white;
      color: $white;

      &::-webkit-calendar-picker-indicator {
        filter: invert(1);
      }    
    }
  }
}

.c-pagination {
  margin-top: auto;
}

.c-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
}
.dropdown {
  position: relative;
  width: 100%;
  max-width: 300px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  font-family: Arial, sans-serif;
}

.dropdown-selector {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f9f9f9;
  cursor: pointer;
}

.dropdown-arrow {
  font-size: 12px;
}

.dropdown-menu {
  position: absolute;
  width: 100%;
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 100;
  max-height: 200px;
  overflow-y: auto;
}

.dropdown-item {
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.dropdown-item:last-child {
  border-bottom: none;
}

input[type="checkbox"] {
  margin-right: 5px;
  cursor: pointer;
}
</style>
